module.exports = __webpack_public_path__ + "static/media/prev-disabled.20929ac0.svg";